import { CollectionList, Form } from '@mairistem/composants';
import _ from 'lodash';
import React, { type ReactNode } from 'react';

import type { AdresseType } from '@/types';

import RegieAdresseListItem from './RegieAdresseListItem';
import RegieAdresseListItemForm from './RegieAdresseListItemForm';

interface RegieAdresseListProps {
  adresse: AdresseType;
  onChange: (e: any) => void;
  control?: React.ReactNode;
  form?: React.ReactNode;
}

const RegieAdresseList = (props: RegieAdresseListProps) => {
  const {
    adresse,
    onChange,
    form = RegieAdresseListItemForm,
    control = RegieAdresseListItem,
  } = props;

  const items = React.useMemo(() => {
    if (adresse) {
      return [
        {
          key: '1',
          adresse: {
            ..._.omit(adresse, [
              'numeroCodePostal',
              'localite',
              'lettre',
              'libellePays',
              'libelleVoie',
            ]),
            codePostal: adresse?.numeroCodePostal,
            commune: adresse?.localite,
            indiceRepetition: adresse?.lettre,
            pays: adresse?.libellePays,
            voie: adresse?.libelleVoie,
          },
        },
      ];
    }

    return [];
  }, [adresse]);

  const handleChange = React.useCallback(
    (e, item) => {
      if (onChange) {
        onChange({
          adresse: {
            ..._.omit(item?.adresse, [
              // on omit l'identifiant, ce sera une nouvelle adresse quoi qu'il arrive
              'identifiant',
              'codePostal',
              'commune',
              'indiceRepetition',
              'pays',
              'voie',
            ]),
            numeroCodePostal: item?.adresse?.codePostal,
            localite: item?.adresse?.commune,
            lettre: item?.adresse?.indiceRepetition,
            libellePays: item?.adresse?.pays,
            libelleVoie: item?.adresse?.voie,
            // 5 caractères max en bd
            complementNumeroVoirie: item?.adresse?.complementNumeroVoirie?.substring(0, 5),
          },
        });
      }
    },
    [onChange],
  );

  return (
    <Form.Group width={16}>
      <Form.Field width={16} required>
        <label>Adresse</label>
        <CollectionList
          limit={1}
          formTitle="Adresse"
          // @ts-expect-error
          items={items}
          onItemCreate={handleChange}
          onItemUpdate={handleChange}
          modalContentProps={{ scrolling: false }}
          itemControl={control as ReactNode}
          itemForm={form as ReactNode}
          style={{ margin: 0 }}
        />
      </Form.Field>
    </Form.Group>
  );
};

export default RegieAdresseList;
